var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "crud crud-edit",
        staticStyle: { width: "100%", height: "100%" },
      },
      [
        _c("iframe", {
          attrs: {
            src: "https://chat.dante-ai.com/embed/?kb_id=a98d004f-76cc-4ca6-a8f5-1bd069715908&token=61fd0404-5ce4-4236-8e67-f6d8a0b4019d&modeltype=gpt-4-omnimodel-mini&tabs=false",
            allow: "clipboard-write; clipboard-read; *;microphone *",
            width: "100%",
            height: "100%",
            frameborder: "0",
          },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }